import { useMemo } from 'react';

import { NamedAvatarContainer } from './style';

export interface NamedAvatarProps {
	name: string | undefined;
	size: number;
}

export function NamedAvatar({ name, size }: NamedAvatarProps) {
	const nameToTwoLetters = useMemo(() => {
		if (!name) {
			return '';
		}

		let letter;
		const p = name.trim().split(' ');
		const deleteSpaces = p.indexOf('');
		if (deleteSpaces !== -1) {
			p.splice(deleteSpaces, 1);
		}
		if (p.length > 1) {
			letter = `${p[0][0]}${p[1][0]}`;
		} else {
			letter = `${name[0]}${name[1]}`;
		}

		return letter;
	}, [name]);

	const calcColorByLetters = useMemo(() => {
		if (!nameToTwoLetters) {
			return '#222222';
		}

		const letters = nameToTwoLetters.split('');
		const alphabetNumbers =
			letters[0].toLowerCase().charCodeAt(0) - 97 + letters[1].toLowerCase().charCodeAt(0) - 97;
		const hue = (360 / 50) * alphabetNumbers;

		return `hsl(${hue}, 68%, 48%)`;
	}, [name]);

	return (
		<NamedAvatarContainer size={size} $background={calcColorByLetters}>
			{nameToTwoLetters}
		</NamedAvatarContainer>
	);
}
